import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title"]
  static values = {
    exportType: String,
    exportUrl: String,
    targetParam: { type: Boolean, default: true }
  }

  openModal(event) {
    event.preventDefault()
    const { exportType, exportUrl, exportTargetParam, exportTitle } = event.currentTarget.dataset

    this.exportTypeValue = exportType || null
    if (exportUrl) {
      this.exportUrlValue = exportUrl
    } else {
      delete this.exportUrlValue
    }
    // 題名は起動要素の data-export-title を優先する(送信する target とは独立に決められるように)
    this.updateTitle(exportType, exportTitle)

    if (exportTargetParam !== undefined) {
      this.targetParamValue = exportTargetParam !== "false"
    } else {
      this.targetParamValue = true
    }

    if (this.hasModalTarget) {
      this.modalTarget.showModal()
    }
  }

  updateTitle(exportType, exportTitle) {
    if (!this.hasTitleTarget) return

    if (exportTitle) {
      this.titleTarget.textContent = exportTitle
      return
    }

    const titles = {
      accounts: 'アカウントサマリー CSVエクスポート',
      stats: '日別推移データ CSVエクスポート',
      inst_accounts: 'アカウント情報 CSVエクスポート',
      tw_accounts: 'アカウント情報 CSVエクスポート',
      followers: 'フォロワー情報 CSVエクスポート',
      line_friends: 'LINE友だち推移 CSVエクスポート',
      fb_pages: 'Facebookページ情報 CSVエクスポート',
      fb_followers: 'Facebookフォロワー推移 CSVエクスポート'
    }

    this.titleTarget.textContent = titles[exportType] || 'CSVエクスポート期間選択'
  }

  closeModal(event) {
    if (event) {
      event.preventDefault()
    }
    if (this.hasModalTarget) {
      this.modalTarget.close()
    }
  }

  downloadCSV(event) {
    event.preventDefault()

    // date-range-calendar コントローラーから calendar-range 要素を取得
    const calendarController = this.application.getControllerForElementAndIdentifier(
      this.modalTarget.querySelector('[data-controller*="date-range-calendar"]'),
      'date-range-calendar'
    )

    if (!calendarController || !calendarController.hasElementTarget) {
      alert('カレンダーが初期化されていません')
      return
    }

    const calendarValue = calendarController.elementTarget.value
    if (!calendarValue || !calendarValue.includes('/')) {
      alert('日付を選択してください')
      return
    }

    const [fromDate, toDate] = calendarValue.split('/')

    // バリデーション
    if (!fromDate || !toDate) {
      alert('開始日と終了日を選択してください')
      return
    }

    const from = new Date(fromDate)
    const to = new Date(toDate)

    if (from > to) {
      alert('開始日は終了日より前の日付を選択してください')
      return
    }

    // "null" などの無効値を除外し、指定がない場合は現在ページの .csv へフォールバック
    const normalizedExportUrl = this.exportUrlValue && this.exportUrlValue !== "null" ? this.exportUrlValue : null
    const baseUrl = normalizedExportUrl || `${window.location.pathname}.csv`
    const url = new URL(baseUrl, window.location.origin)

    if (this.targetParamValue && this.exportTypeValue) {
      url.searchParams.set('target', this.exportTypeValue)
    }

    url.searchParams.set('fromDate', fromDate)
    url.searchParams.set('toDate', toDate)

    // CSVダウンロード（Turboを無効化）
    window.location.href = url.toString()

    // モーダルを閉じる
    this.closeModal()
  }
}
